/**
 * Icon widths rendered in the suggestion list's action cell, mirroring the `size` prop each icon
 * is given in SuggestionList. View, delete and info are always present; edit only shows for
 * supplier logins on rows that still have pending or rejected libraries.
 */
const ACTION_ICON_SIZES = { view: 24, edit: 24, delete: 24, info: 28 };

/** `gap` on `.action-suggestion` in SupplierSuggestion.css. */
const ACTION_ICON_GAP = 10;

/** Bootstrap's `.table td` padding (0.75rem) on both sides of the cell. */
const ACTION_CELL_PADDING = 24;

/**
 * Width the action column needs for the icons it actually renders. The sticky Status column is
 * pinned at this same offset, so an over-wide value leaves dead space to the left of the icons
 * and an under-wide one lets them overflow onto the Status cell's colour bar.
 */
export function getSuggestionActionColumnWidth(hasEditAction: boolean): number {
  const icons = hasEditAction
    ? [ACTION_ICON_SIZES.view, ACTION_ICON_SIZES.edit, ACTION_ICON_SIZES.delete, ACTION_ICON_SIZES.info]
    : [ACTION_ICON_SIZES.view, ACTION_ICON_SIZES.delete, ACTION_ICON_SIZES.info];
  const iconsWidth = icons.reduce((total, size) => total + size, 0);
  return iconsWidth + ACTION_ICON_GAP * (icons.length - 1) + ACTION_CELL_PADDING;
}
